import React from "react";
import { Button } from "components/ui/button";
import { Card, CardContent } from "components/ui/card";
import { Sparkles } from "lucide-react";

interface WelcomeStepProps {
  onNext: () => void;
}

export default function WelcomeStep({ onNext }: WelcomeStepProps) {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-12">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <div className="p-4 bg-gradient-to-br from-[#005151] to-[#004040] rounded-2xl shadow-xl">
              <Sparkles className="h-12 w-12 text-white" />
            </div>
            <div className="absolute -top-2 -right-2 w-6 h-6 bg-emerald-400 rounded-full animate-pulse"></div>
          </div>
        </div>
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Welcome to Health Harbor
        </h1>
      </div>

      <Card className="border border-gray-200 shadow-sm mb-8">
        <CardContent className="p-8">
          <div className="prose max-w-none">
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              Hello!
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              As someone who has spent years witnessing the daily challenges
              faced by healthcare practices, I understand the frustration of
              spending countless hours on insurance verification calls - time waiting on hold and time that
              could be better spent helping patients.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              That's why we built Health Harbor. Our mission is simple: to give
              you back your time by automating the tedious but necessary process
              of working with insurance, so you can focus on what matters most –
              your patients.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              In the next few minutes, we'll help you set up your
              profile and get you ready to experience the future of healthcare
              administration. Our AI will handle those long hold times and
              repetitive calls, delivering accurate results directly to your
              dashboard.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              Welcome to a more efficient way of practicing healthcare.
            </p>
            <div className="flex items-center">
              <div className="text-gray-700">
                <p className="font-semibold">Alan</p>
                <p className="text-sm text-gray-500">
                  CEO & Founder, Health Harbor
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-gradient-to-r from-[#005151]/5 to-emerald-50 border-[#005151]/20">
        <CardContent className="p-8">
          <div className="text-center">
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
              Ready to transform your practice?
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Let's get you set up in just a few minutes. We'll walk you through
              configuring your practice and getting you ready to start saving
              time.
            </p>
            <Button
              onClick={onNext}
              className="bg-[#005151] hover:bg-[#004040] text-white px-8 py-3 text-lg font-medium"
              size="lg"
            >
              Get Started
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
